import React, { useState } from 'react';
import Application from '../Application';
import PropTypes from 'prop-types';
const ExternalApplication = props => {
    const [template, ] = useState(window.PRELOADED_STATE?.externalApplication?.template ?? null);
    return (
        <div>
            <Application
                externalMode={true}
                template={template}
                isTimedout={props.isTimedout}
            />
        </div>
    );
};
ExternalApplication.propTypes = {
    isTimedout: PropTypes.bool
};
export default ExternalApplication;
